import actionTypes from '../constants/action-types';

function setConstraints(constraints) {
  return {
    type: actionTypes.SET_CONSTRAINTS,
    payload: {
      constraints,
    },
  };
}

export default setConstraints;
